export const truncateAfterWords = (str: string, limit = 3) => {
  // split string on any whitespaces
  const words = str.split(/\s+/);
  if (words.length <= limit) return str;
  return words.slice(0, limit).join(" ") + "...";
};
